import { initializeApp } from 'firebase/app';

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: process.env.VUE_APP_FIREBASE_API_KEY,
  authDomain: process.env.VUE_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.VUE_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.VUE_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.VUE_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.VUE_APP_FIREBASE_APP_ID,
  measurementId: process.env.VUE_APP_FIREBASE_MEASUREMENT_ID,
};

// Import @vueuse/head
// This supports the dynamic creation of meta tags for each page
import { createHead } from '@vueuse/head'

// Initialize Firebase
initializeApp(firebaseConfig);

// Set up the router
import { createApp } from 'vue';
import App from './App.vue';
import router from './router'; // Import the router

createApp(App)
  .use(createHead())
  .use(router) // Use the router
  .mount('#app');
